module.exports = __webpack_public_path__ + "img/china-petroleum-card-bg.8c24b5a6.png";